export default __webpack_public_path__ + "static/media/riu.3fdfb136.png";